import { useTranslation } from 'libs/i18n';
import { Chip } from 'libs/ui';

interface ChipProps {
  isArchived: boolean;
}

export const Status = ({ isArchived }: ChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      size="s"
      text={
        isArchived
          ? t('directory.directoryRecord.status.archived')
          : t('directory.directoryRecord.status.active')
      }
      variant={isArchived ? 'gray' : 'green'}
    />
  );
};
